import { MensagemService, ProgressoService } from 'maestro-ng';
import { UsuarioService } from '../usuario/usuario.service';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { KeycloakAuthGuard, KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CodexAuthGuard extends KeycloakAuthGuard {

  constructor(
    protected readonly router: Router,
    protected readonly keycloak: KeycloakService,
    protected readonly autenticacaoService: AutenticacaoService,
    protected readonly usuarioService: UsuarioService,
    protected readonly mensagemService: MensagemService,
    protected readonly progressoService: ProgressoService) {
    super(router, keycloak);
  }

  async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    if (!this.authenticated) {
      await this.keycloak.login({
        redirectUri: window.location.origin + state.url,
      });

    }

    if (!this.autenticacaoService.isAutenticado()) {
      this.keycloak.getToken().then(kcToken => {
        this.logarUsuario(kcToken);
      });
    }

    if (this.authenticated) {
      const forcarRefreshToken = this.forcarRefreshToken();

      this.keycloak.keycloakEvents$.subscribe({
        next: (e) => {
          switch (e.type) {
            case KeycloakEventType.OnAuthRefreshSuccess:
              this.keycloak.getToken().then(token => {
                this.renovarTokenCodex(token);
              });
              break;
            case KeycloakEventType.OnTokenExpired:
              if (!forcarRefreshToken) {
                this.keycloak.updateToken();
              }
              break;
            case KeycloakEventType.OnAuthLogout:
            case KeycloakEventType.OnAuthRefreshError:
              this.autenticacaoService.deslogar(true);
              break;
            default:
            // do nothing
          }
        }
      });
    }
    return this.authenticated;
  }

  private logarUsuario(kcToken: string) {
    this.progressoService.modal();
    this.usuarioService.autenticarUsuarioViaToken(kcToken)
      .then(token => {
        this.autenticacaoService.inicializarSessao(token);
        this.progressoService.fechar();
      })
      .catch(resposta => {
        this.tratarRepostaErro(resposta);
      });
  }

  private renovarTokenCodex(kcToken: string) {
    if (this.isTokenCodexExpiraPrimeiro()) {
      this.usuarioService.autenticarUsuarioViaToken(kcToken)
        .then(token => {
          this.autenticacaoService.processarTokenAtualizado(token);
        })
        .catch(resposta => {
          this.tratarRepostaErro(resposta);
        });
    }
  }

  /**
   * Verifica se o token gerado pelo Codex irá expirar antes do Token gerado pelo SSO.
   * @param difMinima diferença minima em milessegundos (padrão: 20000)
   * @private
   */
  private isTokenCodexExpiraPrimeiro(difMinima?: number) {
    if (this.keycloak.getKeycloakInstance().tokenParsed && this.autenticacaoService.isAutenticado()) {
      difMinima = difMinima || 20000;
      const expKC = this.keycloak.getKeycloakInstance().tokenParsed.exp * 1000;
      const expCodex = this.autenticacaoService.getUsuarioSessao().tokenExpiracao.getTime();
      return expKC > (expCodex - difMinima);
    }
    return true;
  }

  /**
   * Força o refresh token, caso o tempo de expiração do access token seja inferior
   * ao tempo do token gerado pelo Codex.
   * @private
   */
  private forcarRefreshToken() {
    const forcarAtualizacao = this.isTokenCodexExpiraPrimeiro(0);

    if (forcarAtualizacao) {
      setInterval(() => this.keycloak.updateToken(-1).then()
        , environment.duracaoTokenEmMinutos * 60 * 1000);
    }
    return forcarAtualizacao;
  }

  private tratarRepostaErro(resposta) {
    this.autenticacaoService.deslogar(false);
    this.mensagemService.addErro('Erro', 'Erro ao autenticar o usuário. Mensagem interna: ' + resposta.error);
    this.progressoService.fechar();
  }
}
